









import Vue from 'vue';
import moment from 'moment';

// import booth from '@/modules/exhibitor/booth';
// import brand from '@/modules/exhibitor/brand';
// import item from '@/modules/exhibitor/item';

import {
  booth,
  brand,
  item,
} from 'mostra';

import favorite from '@/modules/buyer/favorite';

// import { toDate, isAfterDate } from '@/modules/calender';
import { calender } from '@/modules/calender';
import { sizes, genDownloadImageUrl } from '@/modules/image';

type DataType = {
  loading: boolean;
  checklist: Array<any>;
  drawerVisible: boolean;
};

type BoothType = {
  id: string;
  name: string;
}

export default Vue.extend({
  name: 'buyer-favorites',
  data(): DataType {
    return {
      loading: false,
      checklist: [],
      drawerVisible: false,
    };
  },
  async mounted() {
    await this.loadCheckList();
  },
  methods: {
    async loadCheckList() {
      try {
        this.loading = true;
        this.$loading(true);
        if (this.$auth) {
          const favoriteBrands = await favorite.loadsByOwner(this.$auth.uid);
          const checkedBrands = [];

          if (favoriteBrands && favoriteBrands.length > 0) {
            let favoriteData;
            for (favoriteData of favoriteBrands) {
              if (favoriteData.id && favoriteData.data) {
                const brandData = await brand.load(favoriteData.id);
                let brandInfo;
                if (brandData && brandData.id && brandData.data) {
                  const {
                    base,
                    sns,
                  } = brandData.data;
                  let imageUrl = null;
                  if (base && base.image && base.image.id) {
                    imageUrl = await genDownloadImageUrl(
                      sizes.x512,
                      base.image.id,
                    );
                  }
                  let logoUrl = null;
                  if (base && base.logo && base.logo.id) {
                    logoUrl = await genDownloadImageUrl(
                      sizes.x512,
                      base.logo.id,
                    );
                  }
                  brandInfo = {
                    id: brandData.id,
                    owner: brandData.data.owner,
                    sns,
                    imageUrl,
                    logoUrl,
                    name: base.name,
                    website: base.website,
                  };
                }

                // 出展展示会
                const boothes: BoothType[] = [];
                if (brandData && brandData.id) {
                  const owner = brandData.data.owner ? brandData.data.owner : '';
                  const boothData = await booth.loadsByBrandId(owner, brandData.id);
                  // 開催中の展示会のブースのみ取得
                  const openingBooth = await boothData.filter((targetBooth) => {
                    let endDate = null;
                    const boothBase = targetBooth.data.base;
                    if (!boothBase) return false;
                    if (boothBase.termOfOpeningSite.end) {
                      endDate = calender.toDate(boothBase.termOfOpeningSite.end);
                    }
                    if (boothBase.termOfExhibit.end) {
                      endDate = calender.toDate(boothBase.termOfExhibit.end);
                    }
                    if (!endDate) return false;
                    const today = moment().toDate();
                    return !calender.isAfterDate(today, endDate);
                  });

                  // boothesに必要なデータを挿入
                  if (openingBooth && openingBooth.length > 0) {
                    openingBooth.forEach((targetBooth) => {
                      // TODO: booth名称は不要
                      // TODO: exhの名称とIDがほしい
                      const boothId = targetBooth.id ? targetBooth.id : '';
                      const boothName = targetBooth.data.base.name ? targetBooth.data.base.name : '';
                      boothes.push({
                        id: boothId,
                        name: boothName,
                      });
                    });
                  }
                }

                const items = [];

                let favoriteItem;
                for (favoriteItem of favoriteData.items) {
                  if (favoriteItem.id) {
                    const itemData = await item.load(favoriteItem.id);
                    if (itemData) {
                      const {
                        topImage,
                        name,
                        price,
                        isPriceUndecided,
                      } = itemData.data.base;
                      let imageUrl = null;
                      if (topImage && topImage.id) {
                        imageUrl = await genDownloadImageUrl(sizes.x512, topImage.id);
                      }
                      items.push({
                        id: itemData.id,
                        title: name,
                        price,
                        isPriceUndecided,
                        imageUrl,
                        checked: true,
                      });
                    }
                  }
                }

                checkedBrands.push({
                  ...brandInfo,
                  checked: true,
                  items,
                  booth: boothes,
                });
              }
              this.checklist = checkedBrands;
            }
          }
        }
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.$loading(false);
        this.loading = false;
      }
    },
    async onCheck(brandId: string, itemId?: string) {
      const uid = this.$auth.uid;

      if (!uid) return;

      this.$loading(true);
      if (itemId) {
        // 商品のチェックを外す
        await favorite.checkItem(uid, brandId, itemId, false);
      } else {
        // ブースのチェックを外す
        await favorite.checkBrand(uid, brandId, false);
      }
      await this.loadCheckList();
      this.$loading(false);
    },
  },
});
